
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType';
import { useForm } from '../../hooks/useForm';
import { updateActorFieldValue, updateActorContactInfo } from '../actions';
import { NL_fieldPatterns } from '../util/NL_fieldPatterns';
import { useValidation } from './useValidation';



export const useActor = (containerKey = "headerParties") => {
   const { saveForm } = useForm(containerKey)
   const dispatch = useDispatch();
   const { isDMS, isImportShipment } = useCurrentShipmentType()
   const { validateError } = useValidation('parties')
   const fieldPattern = NL_fieldPatterns(isDMS, isImportShipment)()

   const saveActorDetails = useCallback(async (params = {}, key) => {
      try {
         const type = params.actorType == "carrier" ? "CARRIER_TRADER" : params.actorType.toUpperCase()
         params.type = type
         params.identification = type
         validateError({
            [`${params?.actorType}.${key}`]: ''
         },
            { [`${params?.actorType}`]: { [key]: params?.[key] || `${params?.streetName} ${params?.streetNumber}` } },
            { [`${params?.actorType}.${key}`]: fieldPattern?.parties?.[`${params?.actorType}.${key}`] })
         const response = await saveForm({ [`${params.actorType}`]: params })
         if (response?.responseMessage && !params.id) {
            dispatch(updateActorFieldValue(params.actorType, { "id": response.responseMessage }))
         }
      }
      catch (e) {

      }
   }, [saveForm]);




   return React.useMemo(() => ({
      saveActorDetails,
      clearContactDetails: (actorType) => dispatch(updateActorContactInfo(actorType, { contactName: "", contactEmail: "", contactPhone: "" })),
      updateActorContactInfo: (actorType, payload) => dispatch(updateActorContactInfo(actorType, payload)),
      updateActorFieldValue: (actorType, payload) => dispatch(updateActorFieldValue(actorType, payload)),
      saveActorContactDetails: (actorType, payload) => saveActorDetails({ actorType, contact: payload })
   }), [
      saveActorDetails,
      updateActorContactInfo,
      updateActorFieldValue])
}